module.exports = __webpack_public_path__ + "static/media/bg_women_mobile.61170034.png";